// extracted by mini-css-extract-plugin
module.exports = {"list-group-item":"_1D1InPnpn94cj6uTYAi33Q","border":"_3QdfChHT1vt8IM8Vld8ZYH","horizontal":"mfq2QoyqoSUJRjRyzzLLi"};